import React, {useState} from 'react'
import './layout.css'
import Filters from "../../views/filters";
import NamedQueryModule from "../data_modules/named_query_module";
import Preferences from "./preferences";

const Layout = ({items, prefsPrefix, onDataChanged=()=>{}, children}) => {

    const prefs = Preferences()
    const addDefaults = (charts) => {
        for(var name in charts) {
            charts[name].disabled = prefs.get(prefsKey(name))
        }
        return charts
    }
    const prefsKey = (name) => {
        return prefsPrefix + "-" + name + "-disabled"
    }
    const onCloseClick = (name) => {
        const newModel = JSON.parse(JSON.stringify(model));
        const isDisabled = !newModel[name].disabled
        newModel[name].disabled = isDisabled
        setModel(newModel)
        prefs.put(prefsKey(name), isDisabled)
    }

    const [model, setModel] = useState(addDefaults(items))
    console.log(model)
    const modelAsList = model ? Object.keys(model) : []
    const modules = modelAsList.map(
            (name, i) =>
                <NamedQueryModule
                    queryName={name}
                    source={model[name].source}
                    formatters={model[name].specialFormatters}
                    isDisabled={model[name].disabled}
                    onCloseClick={(e) => {onCloseClick(name)}}
                    onDataChanged={(e) => {onDataChanged(name, e)}}
                    key={i}
                />
            )
    const modules_enabled = modules.filter((m,i) => !model[modelAsList[i]].disabled)
    const modules_disabled = modules.filter((m,i) => model[modelAsList[i]].disabled)
    const Spacer = () => {
        return <div className={"spacer"}/>
    }
    const contents = [].concat(<Filters/>, modules_enabled, <Spacer/>, modules_disabled, children)

    return <div className={"layout"}>
        {contents}
    </div>
}

export default Layout